import styled from 'styled-components';

export const ColorPickerLayout = styled.div`
  position: relative;
  display: flex;
`;
